var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overflow-hidden" }, [
    _c(
      "div",
      { staticClass: "row no-gutters" },
      [
        _vm.CalendarDetails.legend
          ? _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c(
                  "b-card",
                  { staticClass: "mx-2" },
                  [
                    _c("b-card-title", { staticClass: "mb-1" }, [
                      _vm._v(" Legend "),
                    ]),
                    _c(
                      "b-card-body",
                      _vm._l(
                        _vm.CalendarDetails.legend,
                        function (item, index) {
                          return _c(
                            "b-badge",
                            {
                              key: index,
                              staticClass: "mr-1",
                              attrs: { variant: item.variant },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "col-sm-12 position-relative" }, [
          _c(
            "div",
            { staticClass: "card shadow-none border-0 mb-0 rounded-0" },
            [
              _c(
                "div",
                { staticClass: "card-body pb-0" },
                [
                  _c("FullCalendar", {
                    attrs: { options: _vm.calendarOptions },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
        _c(
          "b-sidebar",
          {
            ref: "sidebar",
            attrs: {
              id: "sidebar-right",
              "bg-variant": "white",
              right: "",
              title: "View Job Card",
              backdrop: "",
              shadow: "",
              visible: _vm.showSidebar,
            },
          },
          [
            _c(
              "b-button",
              {
                staticClass: "mt-1 w-100",
                attrs: { size: "sm" },
                on: {
                  click: function ($event) {
                    return _vm.goToPage(_vm.selectedItem)
                  },
                },
              },
              [_vm._v(" View ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }